/**
 * The client contract.
 *
 * Exports the GENERATED schemas, not the drizzle-derived ones. The Drizzle
 * schema is still the source of truth (ADR-0008) -- `src/derived.ts` builds
 * from it and `scripts/generate-schemas.ts` serialises the result -- but a
 * client importing `derived.ts` would bundle the ORM (ADR-0022).
 *
 * Nothing in this file's import graph may reach `drizzle-orm`, `drizzle-zod`
 * or `@tabletop/db`. There is a test asserting exactly that.
 */
export * from "./generated.js";
export * from "./enrichment.js";
